export const isActiveFeature = (features: readonly string[], feature: string): boolean => features.includes(feature);
